import { ChartType } from '../../../API';
import { ChartCard } from './charts';

export const chartCardList: ChartCard[] = [
  {
    type: ChartType.BAR,
    title: 'Bar',
    subtitle: 'Compare values across categories',
    icon: 'bar-chart',
    displayConfig: {
      chartTitle: true,
      xAxisLabel: true,
      yAxisLabel: true,
      xAxisValue: true,
      yAxisValue: true,
      chartColor: true,
      barWidth: true,
      xAxisGridLines: true,
      yAxisGridLines: true,
    },
  },
  {
    type: ChartType.LINE,
    title: 'Line',
    subtitle: 'Show trends over time',
    icon: 'line-chart',
    displayConfig: {
      chartTitle: true,
      xAxisLabel: true,
      yAxisLabel: true,
      xAxisValue: true,
      yAxisValue: true,
      chartColor: true,
      xAxisGridLines: true,
      yAxisGridLines: true,
    },
  },
  {
    type: ChartType.PIE,
    title: 'Pie',
    subtitle: 'Show proportions of a whole',
    icon: 'pie-chart',
    displayConfig: {
      chartTitle: true,
      category: true,
      categoryValue: true,
      colorPalette: true,
    },
  },
  {
    type: ChartType.SCATTER,
    title: 'Scatter',
    subtitle: 'Show corelation between variables',
    icon: 'dot-chart',
    displayConfig: {
      chartTitle: true,
      xAxisLabel: true,
      yAxisLabel: true,
      xAxisValue: true,
      yAxisValue: true,
      chartColor: true,
      pointSize: true,
      xAxisGridLines: true,
      yAxisGridLines: true,
    },
  },
  {
    type: ChartType.GEO,
    title: 'Geo',
    subtitle: 'Visualize geographic data',
    icon: 'global',
    displayConfig: {
      chartTitle: true,
      colorPalette: true,
      location: true,
      locationValue: true,
      mapType: true,
    },
  },
];
export const US_STATE_MAPPINGS: any = {
  AL: 'Alabama',
  AK: 'Alaska',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
};

export const COLOR_PALETTES = [
  {
    id: 1,
    colors: [
      '#013369',
      '#0A4C8A',
      '#1E90FF',
      '#D50A0A',
      '#FF4C4C',
      '#800000',
      '#808080',
      '#A9A9A9',
      '#5A5A5A',
      '#2F2F2F',
    ],
    label: 'NFL League Brand Palette',
  },
  {
    id: 2,
    colors: ['#5470C6', '#91CC75', '#EE6666', '#FAC858', '#73C0DE', '#3BA272', '#FC8452', '#9A60B4', '#EA7CCC'],
    label: 'ECharts Classic',
  },
  {
    id: 3,
    colors: [
      '#4E79A7',
      '#F28E2B',
      '#E15759',
      '#76B7B2',
      '#59A14F',
      '#EDC948',
      '#B07AA1',
      '#FF9DA7',
      '#9C755F',
      '#BAB0AC',
    ],
    label: 'Tableau 10',
  },
  {
    id: 4,
    colors: [
      '#1F77B4',
      '#FF7F0E',
      '#2CA02C',
      '#D62728',
      '#9467BD',
      '#8C564B',
      '#E377C2',
      '#7F7F7F',
      '#BCBD22',
      '#17BECF',
    ],
    label: 'D3 Category10',
  },
  {
    id: 5,
    colors: [
      '#A1C9F4',
      '#FFB482',
      '#8DE5A1',
      '#FF9F9B',
      '#D0BBFF',
      '#FFFEA3',
      '#B9F2F0',
      '#E6C9A8',
      '#FAB0E4',
      '#CFCFCF',
    ],
    label: 'Pastel Bright',
  },
  {
    id: 6,
    colors: ['#E41A1C', '#377EB8', '#4DAF4A', '#984EA3', '#FF7F00', '#FFFF33', '#A65628', '#F781BF', '#999999'],
    label: 'High Contrast',
  },
  {
    id: 7,
    colors: [
      '#F44336',
      '#E91E63',
      '#9C27B0',
      '#673AB7',
      '#3F51B5',
      '#2196F3',
      '#009688',
      '#4CAF50',
      '#FF9800',
      '#795548',
    ],
    label: 'Material Design',
  },
  {
    id: 8,
    colors: [
      '#440154',
      '#482777',
      '#3E4989',
      '#31688E',
      '#26828E',
      '#1F9E89',
      '#35B779',
      '#6DCD59',
      '#B4DE2C',
      '#FDE725',
    ],
    label: 'Viridis (Perceptually Uniform)',
  },
];
